import template from 'text!./templates/currency.html';

export default [function () {
    return {
        restrict: 'E',
        scope: { item: '&' },
        template: template
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/readonly-table/Currency.js
// module id = 282
// module chunks = 0